import { ForwardedRef, forwardRef, memo } from 'react';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Box, FlatSelect, TextInput } from '@betty/moonlight';

export const GenderMap: Record<string, string> = {
  female: 'Female',
  male: 'Male',
  other: 'Non Binary',
};

const options = Object.keys(GenderMap).map((id) => ({
  id,
  label: GenderMap[id],
}));

function GenderField(
  {
    onValue,
    value,
    headerNS,
    headerKey,
    placeholderNS,
    placeholderKey,
  }: RegistrationFieldProps<'gender'>,
  ref: ForwardedRef<TextInput>,
) {
  return (
    <Box>
      <FlatSelect
        ref={ref}
        headerNS={headerNS}
        headerKey={headerKey}
        scrollEnabled={false}
        placeholderNS={placeholderNS}
        placeholderKey={placeholderKey}
        onValue={onValue}
        columns={1}
        options={options}
        value={value}
      />
    </Box>
  );
}

export default memo(forwardRef(GenderField));
